module.exports = __webpack_public_path__ + "img/example1.a72584ae.jpg";